import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbInputText as ClbInputText_ } from '@celebration/design-system/dist/lib/input-text';
const events = {
    onClbChange: ClbInputText_.events
        .onClbChange,
};
export const ClbInputText = createComponent({
    tagName: ClbInputText_.tagName,
    elementClass: ClbInputText_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map